module.exports = __webpack_public_path__ + "img/vosvos.4fad8e95.svg";